// React-Query keys
export enum Query {
  FormData = 'formData',
  FormUsers = 'formUsers',
  ShareHistory = 'shareHistory',
  FunctionMembers = 'functionMembers',
  TenantMembers = 'tenantMembers',
  RewardAdminChangeMarker = 'rewardAdminChangeMarker',
  Token = 'token',
  PostcodeLookup = 'PostcodLookup',
}

export type Notification = { header: string; content: string };

export enum Status {
  NotStarted = 'Not Started',
  NotDue = 'Not due',
  NilReturn = 'Nil Return',
  InProgress = 'In Progress',
  Completed = 'Completed',
}

export enum Button {
  SaveUnfinished = 'save-unfinished',
  Save = 'save',
}

export const LastLocation = 'lastLocation';
